import React from 'react';
import { BodyTextRegularC } from '@/shared/ui/typography2';
import { GoogleAuth } from './components';
import { TelegramAuth } from './components';
import { useScopedI18n } from '@locales/client';

import {
  WraperGroupAuthVariant,
  Divider,
  DividerLine,
  DividerText,
} from './styles';

export const GroupAuthVariant = () => {
  const t = useScopedI18n('bonus.card');

  return (
    <>
      <Divider>
        <DividerLine />
        <DividerText>
          <BodyTextRegularC color="#AFAFAF">{t('or')}</BodyTextRegularC>
        </DividerText>
        <DividerLine />
      </Divider>
      <WraperGroupAuthVariant>
        <TelegramAuth />
        <GoogleAuth />
      </WraperGroupAuthVariant>
    </>
  );
};
